import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7268154a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Hardware", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Indien uw computer defect is geraakt, is het niet altijd nodig om deze in zijn geheel te vervangen. Afhankelijk van de leeftijd van uw computer, kan het rendabel zijn om enkel het kapotte component te vervangen. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Het is eventueel ook mogelijk om de computer sneller te maken voor specifieke taken. Denk bijvoorbeeld aan het vernieuwen van de videokaart, zodat de nieuwste spelletjes zonder problemen gespeeld kunnen worden. MaatComputers kijkt naar de staat van uw huidige computer om zo een passende oplossing te verzinnen. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Besturingssysteem", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Om veilig te kunnen internetten en om compatibiliteitsproblemen te voorkomen, is het belangrijk dat u gebruik maakt van een ondersteund besturingssysteem. Een ondersteund besturingssysteem wordt actief onderhouden door de ontwikkelaar, wat de veiligheid en compatibiliteit ten goede komt. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Indien uw huidige computer gebruik maakt van een niet-ondersteund besturingssysteem, is het verstandig om het besturingssysteem te vervangen. Vaak is het mogelijk om het besturingssysteem te vernieuwen, afhankelijk van de leeftijd van de computer. ", -1))
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Revisie",
      displaySearchForm: false
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createElementVNode("img", { src: $data.revisieImage }, null, 8, _hoisted_8)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout)
  ], 64))
}